<template>
  <KycDesktop
    :ratio="3/8"
    :title="$t('kyc.titles.financial', { year: previousYear })"
    back-route="/kyc/desktop/financial/introduction"
    @next="next"
  >
    <BaseSmallTitle class="mb-1">{{ $t('kyc.questions.property') }}</BaseSmallTitle>
    <BaseParagraph class="mb-4">
      {{ $t('kyc.labels.property') }}
    </BaseParagraph>
    <AmountSelects
      :amount="attributes.propertyAmount"
      :spouse-amount="attributes.spousePropertyAmount"
      :holding-amount="attributes.holdingPropertyAmount"
      class="mb-8"
      @amount="attributes.propertyAmount = $event"
      @spouse="attributes.spousePropertyAmount = $event"
      @holding="attributes.holdingPropertyAmount = $event"
    />
    <BaseSmallTitle class="mb-1">{{ $t('kyc.questions.cash') }}</BaseSmallTitle>
    <BaseParagraph class="mb-4">
      {{ $t('kyc.labels.cash') }}
    </BaseParagraph>
    <AmountSelects
      :amount="attributes.cashAmount"
      :spouse-amount="attributes.spouseCashAmount"
      :holding-amount="attributes.holdingCashAmount"
      class="mb-8"
      @amount="attributes.cashAmount = $event"
      @spouse="attributes.spouseCashAmount = $event"
      @holding="attributes.holdingCashAmount = $event"
    />
    <BaseSmallTitle class="mb-1">{{ $t('kyc.questions.ventureCapital') }}</BaseSmallTitle>
    <BaseParagraph class="mb-4">
      {{ $t('kyc.labels.ventureCapital') }}
    </BaseParagraph>
    <AmountSelects
      :amount="attributes.ventureCapitalAmount"
      :spouse-amount="attributes.spouseVentureCapitalAmount"
      :holding-amount="attributes.holdingVentureCapitalAmount"
      class="mb-8"
      @amount="attributes.ventureCapitalAmount = $event"
      @spouse="attributes.spouseVentureCapitalAmount = $event"
      @holding="attributes.holdingVentureCapitalAmount = $event"
    />
    <BaseSmallTitle class="mb-1">{{ $t('kyc.questions.otherInvestments') }}</BaseSmallTitle>
    <BaseParagraph class="mb-4">
      {{ $t('kyc.labels.otherInvestments') }}
    </BaseParagraph>
    <AmountSelects
      :amount="attributes.otherInvestmentsAmount"
      :spouse-amount="attributes.spouseOtherInvestmentsAmount"
      :holding-amount="attributes.holdingOtherInvestmentsAmount"
      class="mb-8"
      @amount="attributes.otherInvestmentsAmount = $event"
      @spouse="attributes.spouseOtherInvestmentsAmount = $event"
      @holding="attributes.holdingOtherInvestmentsAmount = $event"
    />
    <BaseSmallTitle class="mb-1">{{ $t('kyc.questions.debts') }}</BaseSmallTitle>
    <BaseParagraph class="mb-4">
      {{ $t('kyc.labels.debts') }}
    </BaseParagraph>
    <AmountSelects
      :amount="attributes.debtsAmount"
      :spouse-amount="attributes.spouseDebtsAmount"
      :holding-amount="attributes.holdingDebtsAmount"
      class="mb-8"
      @amount="attributes.debtsAmount = $event"
      @spouse="attributes.spouseDebtsAmount = $event"
      @holding="attributes.holdingDebtsAmount = $event"
    />
    <BaseSmallTitle class="mb-1">{{ $t('kyc.questions.salary') }}</BaseSmallTitle>
    <BaseParagraph class="mb-4">
      {{ $t('kyc.labels.salary') }}
    </BaseParagraph>
    <AmountSelects
      :amount="attributes.salary"
      :spouse-amount="attributes.spouseSalary"
      :no-holding="true"
      :display-salary-options="true"
      class="mb-8"
      @amount="attributes.salary = $event"
      @spouse="attributes.spouseSalary = $event"
    />
  </KycDesktop>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import moment from 'moment';
import { every, at, isString } from 'lodash';
import KycDesktop from '../Desktop.vue';
import BaseSubtitle from '../../../components/BaseSubtitle.vue';
import BaseSmallTitle from '../../../components/BaseSmallTitle.vue';
import BaseParagraph from '../../../components/BaseParagraph.vue';
import AmountSelects from '../AmountSelects.vue';
import kyc from '../../../mixins/kyc';

export default {
  name: 'Financial',
  components: {
    KycDesktop,
    BaseSubtitle,
    BaseSmallTitle,
    BaseParagraph,
    AmountSelects,
  },
  mixins: [kyc],
  data() {
    return {
      previousYear: (moment().year() - 1),
    };
  },
  computed: mapFields('kyc', ['form.attributes']),
  methods: {
    checkAttributes(...attributes) {
      return every(at(this.attributes, attributes), isString);
    },
    next() {
      this.update();
      this.$router.push('/kyc/desktop/knowledge');
    },
  },
};
</script>
